import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import styled from '@emotion/styled';
import { useState } from 'react';
import closedEyeIcon from './assets/eye-closed.svg';
import openEyeIcon from './assets/eye-open.svg';
import { Input, InputType } from './Input';
const PasswordInputWrapper = styled.div({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    position: 'relative',
    '> div': {
        position: 'static',
    },
});
const EyeIcon = styled.img({
    position: 'absolute',
    right: 0,
    padding: '8px',
    cursor: 'pointer',
});
/**
 * @deprecated
 */
export const PasswordInput = ({ fieldId, value, onChange, onBlur, label, error, testID, }) => {
    const [passwordVisible, setPasswordVisible] = useState(false);
    return (_jsxs(PasswordInputWrapper, { children: [_jsx(Input, { type: passwordVisible ? InputType.TextField : InputType.Password, fieldId: fieldId, value: value, onBlur: onBlur, onChange: event => {
                    onChange && onChange(event);
                }, label: label, error: error, testID: testID }), _jsx(EyeIcon, { src: passwordVisible ? openEyeIcon : closedEyeIcon, onClick: () => setPasswordVisible(!passwordVisible) })] }));
};
